
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import ReeferStatus from '../../routecomponents/ReeferStatus';
import ReeferDetails from '../../routecomponents/ReeferDetails';
import VesselStatus from '../../routecomponents/VesselStatus';
import { ReeferStatusGrid } from '../../childcomponents/ReeferStatusGrid';
import Formatters from '../../../actions/Formatters';
import ReeferFormatters from '../../../actions/ReeferFormatter';
import $ from 'jquery';
import { RCUtils } from './../../../RCUtils';
import { PopupWindow } from './../../sharedcomponents/PopupWindow';
import { GridToolBarPopups } from './../../sharedcomponents/GridToolBarPopups';
import { ReeferStatusSSRMGrid } from '../../childcomponents/ReeferStatusSSRMGrid';
// pull in the ag-grid styles we're interested in
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-fresh.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ReeferCellRenderer } from '../../../actions/ReeferCellRenderer';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage:false };

export interface StopPTIGridState {
    SelectedReefers: any[];
    rowData: server.USP_UnitCurrentConditionUI_Model[];
    columnDefs: any[];
    Filters: ForwardCommandParams;
    VCCheckBoxInfo: VCCheckBoxData;
    GridToolBarHtml: any;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

var colDefs;
var self;
export class StopPTI extends React.Component<any, StopPTIGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = new ForwardCommandParams();
        this.state = { SelectedReefers: [], rowData: [], columnDefs: [], Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, GridToolBarHtml: '', IsCommandIssued: false, PrevSelectedItems: [] };
        colDefs = this.createColumnDefs();
        self = this;
    }

    componentDidMount() {
        this.renderGridToolBar();
        var reeferData = this.props.reeferData;
        if (reeferData.length > 0) {
            if (reeferData != undefined && reeferData != null) {
                this.setState({ SelectedReefers: reeferData });
                //this.setState({ rowData: reeferData, SelectedReefers: reeferData });
                $('#globalLoader').show();
                this.GetDataFromAPI(reeferData);
            }
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }

       
       
        
        
    }

    submitStopPTICommand() {
        var command = "StopPretrip";
        this.submitTemperatureCommands(command, null);
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData.length > 0) {
            if (reeferData != undefined && reeferData != null) {
                this.setState({ SelectedReefers: reeferData }); 
                $('#globalLoader').show();
                this.GetDataFromAPI(reeferData);
            }
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    refreshGrid = () => {
        $('#globalLoader').show();
        this.GetDataFromAPI(this.state.SelectedReefers);
        $('#globalLoader').hide();
    };

    GetDataFromAPI(reeferData) {
        self.state.Filters.SelectedReefers = reeferData;
        this.state.Filters.CommandName = "StopPretrip";
        var forwardCommandParams = JSON.stringify(self.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/LoadPTIData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ rowData: data }, ()=> this.renderGridToolBar());
                $('#globalLoader').hide();
            });
    }
    //*-----Start Grid Related-----*//
    submitTemperatureCommands(commandName, paramValue) {
        var refreshGrid = this.props.refreshGrid;
        if (self.state.rowData.length > 0) {
            var selectedData = this.state.VCCheckBoxInfo.selectedVCData;
            if (this.state.VCCheckBoxInfo.enableVCCheckBox == true && (selectedData == null || selectedData.VesselId == 0))
            { PopupWindow.showErrorMessage("Alert", "Please select vessel name"); }
            else {
                $('#globalLoader').show();
                self.state.Filters.CommandName = commandName;
                self.state.Filters.SelectedReefers = self.state.rowData;
                self.state.Filters.TempValue = paramValue;
                self.state.Filters.IsCmdSendViaVC = this.state.VCCheckBoxInfo.enableVCCheckBox;
                self.state.Filters.VesselInfo = this.state.VCCheckBoxInfo.selectedVCData;
                var forwardCommandParams = JSON.stringify(self.state.Filters);

                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/PreTripCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response)
                    .then(data => {
                        //$("#Hide_" + commandName).click();
                        $("#contextMenuModel .btn-close").click();
                        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                        if (refreshGrid == "details")
                            ReeferDetails.refreshReeferDetailsData();
                        else if (refreshGrid == "home") {
                            if (JSON.parse(sessionStorage.getItem('SSRM'))) {
                                ReeferStatusSSRMGrid.refreshDashboardGrid();
                            }
                            else {
                                ReeferStatusGrid.refreshDashboardGrid();
                            }
                        }
                        else if (refreshGrid == "vessel")
                            VesselStatus.refreshVesselStatusGrid();
                        else
                            ReeferStatus.refreshReeferStatusGrid();
                        
                    });
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }
    
    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        //this.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true));
        //this.gridApi.sizeColumnsToFit();
    }

    //removeIndicator(params: any) {
    //    var element = document.createElement("span");
    //    element.className = "reefer-delete";

    //    var imageElement = document.createElement("img");
    //    imageElement.src = deletepng;
    //    imageElement.title = "Remove";

    //    imageElement.onclick = function DeleteCommands() {
    //        params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
    //        params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
    //    }

    //    element.appendChild(imageElement);

    //    return element;
    //}

    createColumnDefs() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "T set ", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "RH set", field: "HumiditySetpoint", cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 90 },
            { headerName: "Last event", field: "EventDescription", cellRenderer: (params) => { return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList, self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts); }, width: 150 },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 150 },
            { headerName: "Last pretrip time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "LastPreTripDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 160 },
            { headerName: "PTI state", field: "PTIState", cellRenderer: Formatters.RefCommandStatus, width: 150 }
        ];
    }
    //*-----End Grid Related-----*//

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    renderGridToolBar() {
        this.setState({ GridToolBarHtml: this.renderGridToolBarHtml() });
    }

    renderGridToolBarHtml() {
        return <GridToolBarPopups refreshGrid={this.refreshGrid.bind(this)} gridData={this.state.rowData} colDefs={colDefs} parentchild={"P"} formName={"StopPTI"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)} />;
    }

    public render() {
        return <div>   
            <div>
                {this.state.GridToolBarHtml}
            </div>
                <div className="ag-theme-fresh containerstyle_commands">
                    <AgGridReact
                        columnDefs={colDefs}
                        rowData={this.state.rowData}
                        onGridReady={this.onGridReady}
                        pagination={true}
                        accentedSort={true}
                        paginationPageSize={25}>
                    </AgGridReact>
                </div>         
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitStopPTICommand.bind(this)}>Save</button>
               
            </div>
        </div>        
    }
}

class ForwardCommandParams {
    SelectedReefers: server.USP_UnitCurrentConditionUI_Model[];
    CommandName: string;
    TempValue: any;
    IsCmdSendViaVC?: Boolean
    VesselInfo: server.VesselInformation; 
}